module.exports = __webpack_public_path__ + "vue/img/forbidden.f51eb96a.svg";